import React, { useState } from "react";
import { formatDateWithoutTime } from "../../utils/formateDate";
import { useTranslation } from "react-i18next";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { months } from "../../utils/months";
import ProgressBar from "react-bootstrap/ProgressBar";
import { useNavigate, useParams } from "react-router";
import HistoryModal from "../Incentives/HistoryModal";

const ForeverDrive = ({ chairmanBonus }) => {
  const { t } = useTranslation();
  const [showSupervisorModal, setShowSupervisorModal] = useState(false);
  const navigate = useNavigate();

  const handleExpand = () => {
    navigate("/chairman-bonus");
  };
  const supervisorHeaders = [
    "#",
    "Leg Name",
    "User Name ",
    "Chairman Bonus Level",
  ];
  const supervisorRows = chairmanBonus?.cbLines?.rows?.map(
    (supervisor, idx) => ({
      "#": idx + 1,
      "Leg Name": supervisor.legName || "N/A",
      "User Name": supervisor.cbusername || "N/A",
      "Chairman Bonus Level": supervisor.chairmanBonusLevel || "N/A",
    })
  );

  // Handle supervisor modal - changed to click instead of hover
  const handleSupervisorClick = () => {
    setShowSupervisorModal(true);
  };

  const closeSupervisorModal = () => {
    setShowSupervisorModal(false);
  };

  return (
    <div className="col-md-6">
      <div className="joinings_viewBox">
        <div className="joinings_viewBox_head">
          <h5>{t("chairmanBonus")}</h5>
          <p style={{ textAlign: "right" }}>
            {" "}
            <a className="btn btn-tree-act" onClick={handleExpand}>
              <i className="fa fa-expand"></i>
            </a>
          </p>
        </div>
        <div className="teammbrs_cnt">
          {!chairmanBonus ? (
            <div className="teammbrs_cnt_row">
              <div className="teammbrs_cnt_img">
                <Skeleton
                  width="45px"
                  height="45px"
                  circle
                  containerClassName="avatar-skeleton"
                  count={3}
                />
              </div>
              <div className="teammbrs_cnt_name_dtl">
                <div className="teammbrs_cnt_name">
                  <Skeleton count={6} />
                </div>
              </div>
            </div>
          ) : chairmanBonus?.length === 0 ? (
            <div className="no-data-div">
              <div className="no-data-div-image">
                <img src="/images/nodata-image.png" alt="" />
              </div>
              <p>{t("noDataFound")}</p>
            </div>
          ) : (
            <div className="row">
              <div className="forver_content">
                <span className="key">{t("QualificationLevel")}</span>
                <span className="value">
                  {chairmanBonus?.userDetails.chairmansLevel > 0
                    ? ` Level  ${chairmanBonus?.userDetails.chairmansLevel} `
                    : "NA"}
                </span>
              </div>
              <div className="forver_content">
                <span className="key">{t("EarnedIncentiveRequires")}</span>
                <span className="value">
                  <div
                    style={{
                      height: "15px",
                      width: "15px",
                      border: "1px solid",
                      float: "right",
                      backgroundColor:
                        chairmanBonus?.earnedInctives?.count > 0
                          ? "green"
                          : "none",
                    }}
                  ></div>
                </span>
              </div>
              <div className="forver_content">
                <span className="key">{t("4kcActive")}</span>
                <span className="value">
                  <div
                    style={{
                      height: "15px",
                      width: "15px",
                      border: "1px solid",
                      float: "right",
                      backgroundColor: chairmanBonus?.userDetails?.userActive
                        ? "green"
                        : "none",
                    }}
                  ></div>
                </span>
              </div>
              <div
                style={{
                  display: "flex", // Enables Flexbox
                  gap: "30px", // Space between items
                  justifyContent: "start", // Align items horizontally (start, center, space-between, etc.)
                  alignItems: "flex-start",
                  flexWrap: "wrap",
                  // border: "1px solid grey",
                  padding: "10px",
                  // Wrap items if they overflow
                  width: "100%",
                }}
              >
                {chairmanBonus.points.map((obj, index) => (
                  <div
                    key={index}
                    className="forver_month"
                    style={{
                      display: "flex",
                      flexDirection: "column", // Stack bar above label
                      alignItems: "center", // Center-align the bar and label within each block
                    }}
                  >
                    <div
                      style={{
                        height: "20px",
                        width: "20px",
                        border: "1px solid green",
                        backgroundColor:
                          obj?.activeStatus > 0 ? "green" : "none", // Conditional coloring
                      }}
                    ></div>
                    <span style={{ fontSize: "12px" }}>
                      {months[obj.month].substring(0, 3)}
                    </span>
                  </div>
                ))}
              </div>
              <div
                className="row forever_table"
                style={{
                  padding: "15px",
                  justifyItems: "center",
                  width: "100%",
                }}
              >
                <table className="table">
                  <thead>
                    <tr>
                      <td></td>
                      <td>{t("Level 1")}</td>
                      <td>{t("Level 2")}</td>
                      <td>{t("Level 3")}</td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <div>
                          {t("Personal + N/L KC")} ({t("You Have:")}{" "}
                          {parseFloat(
                            chairmanBonus?.userData?.userTotalPv || 0
                          ).toFixed(3)}
                          )
                        </div>
                      </td>
                      <td>
                        <ProgressBar
                          now={
                            chairmanBonus?.userData
                              ? parseFloat(
                                  chairmanBonus?.userData?.userTotalPv ?? 0
                                )
                              : 0
                          }
                          label={`${parseFloat(
                            chairmanBonus?.userData?.userTotalPv || 0
                          ).toFixed(3)} / ${
                            chairmanBonus?.chairmanLevels?.[0]?.totalPv || 0
                          }`}
                          variant="success"
                          max={
                            chairmanBonus?.chairmanLevels?.[0]?.totalPv || 100
                          }
                          style={{ minHeight: "25px", fontSize: "12px" }}
                        />
                        {chairmanBonus?.chairmanLevels?.[0]?.totalPv || 0}{" "}
                        {t("Required")}
                      </td>
                      <td>
                        <ProgressBar
                          now={
                            chairmanBonus?.userData
                              ? parseFloat(
                                  chairmanBonus?.userData?.userTotalPv ?? 0
                                )
                              : 0
                          }
                          label={`${parseFloat(
                            chairmanBonus?.userData?.userTotalPv || 0
                          ).toFixed(3)} / ${
                            chairmanBonus?.chairmanLevels?.[1]?.totalPv || 0
                          }`}
                          variant="success"
                          max={
                            chairmanBonus?.chairmanLevels?.[1]?.totalPv || 100
                          }
                          style={{ minHeight: "25px", fontSize: "12px" }}
                        />
                        {chairmanBonus?.chairmanLevels?.[1]?.totalPv || 0}{" "}
                        {t("Required")}
                      </td>
                      <td>
                        <ProgressBar
                          now={
                            chairmanBonus?.userData
                              ? parseFloat(
                                  chairmanBonus?.userData?.userTotalPv ?? 0
                                )
                              : 0
                          }
                          variant="success"
                          label={`${parseFloat(
                            chairmanBonus?.userData?.userTotalPv || 0
                          ).toFixed(3)} / ${
                            chairmanBonus?.chairmanLevels?.[2]?.totalPv || 0
                          }`}
                          max={
                            chairmanBonus?.chairmanLevels?.[2]?.totalPv || 100
                          }
                          style={{ minHeight: "25px", fontSize: "12px" }}
                        />
                        {chairmanBonus?.chairmanLevels?.[2]?.totalPv || 0}{" "}
                        {t("Required")}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div>
                          {t("New N/L KC")}
                          <p>
                            ({t("You Have")}{" "}
                            {parseFloat(
                              chairmanBonus?.userData?.userNewPv ?? 0
                            ).toFixed(3)}
                            )
                          </p>
                        </div>
                      </td>
                      <td>
                        <ProgressBar
                          now={
                            chairmanBonus?.userData
                              ? parseFloat(
                                  chairmanBonus?.userData?.userNewPv ?? 0
                                )
                              : 0
                          }
                          variant="success"
                          label={`${parseFloat(
                            chairmanBonus?.userData?.userNewPv || 0
                          ).toFixed(3)} / ${
                            chairmanBonus?.chairmanLevels?.[0]?.newPv || 0
                          }`}
                          max={chairmanBonus?.chairmanLevels?.[0]?.newPv || 100}
                          style={{ minHeight: "25px", fontSize: "12px" }}
                        />
                        {chairmanBonus?.chairmanLevels?.[0]?.newPv || 0}{" "}
                        {t("Required")}
                      </td>
                      <td>
                        <ProgressBar
                          now={
                            chairmanBonus?.userData
                              ? parseFloat(
                                  chairmanBonus?.userData?.userNewPv ?? 0
                                )
                              : 0
                          }
                          variant="success"
                          label={`${parseFloat(
                            chairmanBonus?.userData?.userNewPv || 0
                          ).toFixed(3)} / ${
                            chairmanBonus?.chairmanLevels?.[1]?.newPv || 0
                          }`}
                          max={chairmanBonus?.chairmanLevels?.[1]?.newPv || 100}
                          style={{ minHeight: "25px", fontSize: "12px" }}
                        />
                        {chairmanBonus?.chairmanLevels?.[1]?.newPv || 0}{" "}
                        {t("Required")}
                      </td>
                      <td>
                        <ProgressBar
                          now={
                            chairmanBonus?.userData
                              ? parseFloat(
                                  chairmanBonus?.userData?.userNewPv ?? 0
                                )
                              : 0
                          }
                          variant="success"
                          label={`${parseFloat(
                            chairmanBonus?.userData?.userNewPv || 0
                          ).toFixed(3)} / ${
                            chairmanBonus?.chairmanLevels?.[2]?.newPv || 0
                          }`}
                          max={chairmanBonus?.chairmanLevels?.[2]?.newPv || 100}
                          style={{ minHeight: "25px", fontSize: "12px" }}
                        />
                        {chairmanBonus?.chairmanLevels?.[2]?.newPv || 0}{" "}
                        {t("Required")}
                      </td>
                    </tr>
                    <tr>
                      <td>
              
                        <div
                          onClick={
                            chairmanBonus?.cbLines?.count > 0
                              ? handleSupervisorClick
                              : undefined
                          }
                          style={{
                            cursor:
                              chairmanBonus?.cbLines?.count > 0
                                ? "pointer"
                                : "default",
                            color:
                              chairmanBonus?.cbLines?.count > 0
                                ? "#007bff"
                                : "#333",
                            textDecoration:
                              chairmanBonus?.cbLines?.count > 0
                                ? "underline"
                                : "none",
                            position: "relative",
                            padding: "5px 10px",
                            borderRadius: "4px",
                            transition: "background-color 0.2s",
                          }}
                          onMouseEnter={
                            chairmanBonus?.cbLines?.count > 0
                              ? (e) => {
                                  e.target.style.backgroundColor = "#f8f9fa";
                                }
                              : undefined
                          }
                          onMouseLeave={
                            chairmanBonus?.cbLines?.count > 0
                              ? (e) => {
                                  e.target.style.backgroundColor =
                                    "transparent";
                                }
                              : undefined
                          }
                        >
                          {t("CBLines")}
                           <p>
                            ({t("You Have")}: {chairmanBonus?.cbLines?.count})
                          </p>
                        </div>

                        <div>{t("OR")}</div>
                        <div>
                         {t("600 KC Ldr Lines")}
                          <p>({t("You Have")}: {chairmanBonus?.downlines?.count})</p>
                        </div>
                      </td>

                      {chairmanBonus?.chairmanLevels?.map((level, index) => (
                        <td key={index}>
                          <div><p style={{padding:"14px 10px"}}>{level?.downlineCbmCount ?? 0}</p>
                          <div></div></div>
                          <div><p style={{padding:"14px 10px"}}>OR</p></div>
                          <div><p style={{padding:"14px 10px"}}>{level?.downlineManagerCount ?? 0}</p></div>
                        </td>
                      ))}
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>
      </div>
      <HistoryModal
  show={showSupervisorModal}
  onClose={closeSupervisorModal}
  title={`Chairman Bonus  Details (${chairmanBonus?.cbLines?.count || 0} Total)`}
  headers={supervisorHeaders}
  rows={supervisorRows}
  footer={
    <div>
      <small className="text-muted">
        Total {t("CBLines")}: <strong>{chairmanBonus?.cbLines?.count || 0}</strong>
      </small>
    </div>
  }
/>
    </div>
  );
};

export default ForeverDrive;
